// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:960px){.page.page--full[data-v-2ab1e204]{justify-content:center;padding-top:2rem;padding-bottom:2rem}}", ""]);
// Exports
module.exports = exports;
